import { Room } from '../../models/room';

export class SetRooms {
    public static readonly type = '[MessagingState] Set rooms';

    constructor(public rooms: Room[]) {}
}
